import React, { useMemo } from 'react';
import Chart from 'react-apexcharts';

interface IData {
  x: any;
  y: any;
}

interface IProps {
  options?: any;
  data: Array<IData>;
  previousData?: Array<IData>;
  yName?: string;
}

const defaultOptions = {
  dataLabels: {
    enabled: false,
  },
  xaxis: {
    categories: ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'],
  },
  animations: {
    enabled: true,
    easing: 'easeinout',
    speed: 800,
    animateGradually: {
      enabled: true,
      delay: 150,
    },
    dynamicAnimation: {
      enabled: true,
      speed: 350,
    },
  },
  colors: ['#fff'],
};

const ColumnChart: React.FC<IProps> = ({ options, data, previousData }) => {
  const formattedData = useMemo(() => {
    if (!data) return {};
    const series: any = [];
    const categories: any = [];
    data.forEach(d => {
      categories.push(d.x);
      series.push(d.y);
    });
    return { series, categories };
  }, [data]);

  const previousFormattedData = useMemo(() => {
    if (!previousData) return {};
    const series: any = [];
    const categories: any = [];
    previousData.forEach(d => {
      categories.push(d.x);
      series.push(d.y);
    });
    return { series, categories };
  }, [data]);

  const mergedOptions = {
    ...defaultOptions,
    ...(options || {}),
    xaxis: {
      ...(options || {}).xaxis,
      categories: formattedData.categories,
    },
  };

  const series = [
    {
      data: formattedData.series,
      name: 'Current Period',
    },
    {
      data: previousFormattedData.series,
      name: 'Previous Period',
    },
  ];

  return (
    <>
      <Chart options={mergedOptions} series={series} type="bar" />
    </>
  );
};

export default ColumnChart;
